import React, { useState, useContext } from 'react';
import { WebRTCContext } from '../../contexts/WebRTCContext';

function MonitoringTab() {
    const peerConnection = useContext(WebRTCContext);
    const [sessions, setSessions] = useState([]);
    const [selectedSession, setSelectedSession] = useState(null);

    return (
        <div>
            <h2>Monitoring</h2>
            <p>Monitoring content will go here</p>
        </div>
    );
}

export default MonitoringTab;
